import type { RuntimeConfig } from "@/app/use-runtime-config";
import type { JudgeModelOption, PushPlatform } from "./types";

/* The entries saas-server adds to /api/runtime-config, typed here
 * because core's document does not know them. */
export interface HostedRuntimeConfig extends RuntimeConfig {
  signup_enabled?: boolean;
  billing_enabled?: boolean;
  /* Whether this deployment runs the chokepoint MCP gateway (it needs
   * the encryption key), and the origin agents reach it on, empty when
   * the deployment has not said. */
  gateway_enabled: boolean;
  gateway_url: string;
  /* The judge models llm_judge blocks may pick, in picker order with the
   * default marked; empty when the deployment configured none, in which
   * case judge blocks can be neither created nor activated. */
  llm_judge_models: JudgeModelOption[];
  /* The contact kinds this edition delivers to: text messages when a
   * Twilio sender is configured, WhatsApp when a WhatsApp sender is on
   * top of it, and the phone apps when a push key is held for at least
   * one of them, which push_platforms names. */
  sms_enabled: boolean;
  whatsapp_enabled: boolean;
  push_enabled: boolean;
  push_platforms: PushPlatform[];
  /* Whether this deployment wired the enterprise connector, so the
   * phone apps offer enterprise single sign-on. The web bundle serves
   * its SSO door regardless: the routes answer for themselves. */
  native_sso: boolean;
  /* Whether this deployment has a model that can write request
   * summaries, so organizations can turn them on or off. */
  request_summaries_enabled: boolean;
  /* The PostHog project key the app records sessions with, empty when
   * the deployment records nothing. */
  posthog_key?: string;
}

export function hosted(config: RuntimeConfig): HostedRuntimeConfig {
  return config as HostedRuntimeConfig;
}
